import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { Router } from '@angular/router'
import { State, Types, Store, Observable, User, AppFields } from '../../store'

@Component({
  selector: 'app-full-screen-menu-com',
  templateUrl: 'full-screen-menu.com.html',
  styleUrls: ['full-screen-menu.scss']
})

export class FullScreenMenuComponent implements OnInit {

  @Input() show = false
  @Output() event = new EventEmitter<any>()
  user: Observable<User>
  model = {
    logo: '虾丸云帐',
    items: [
      { name: '库存', icon: 'glyphicon-th-large', link: '/inventory' },
      { name: '批次', icon: 'glyphicon-globe', link: '/batches' },
      { name: '入库', icon: 'glyphicon-download-alt', link: '/import' },
      { name: '财务', icon: 'glyphicon-usd', link: '/finance' },
      { name: '运营', icon: 'glyphicon-pushpin', link: '/operation' },
      { name: '关于', icon: 'glyphicon-plane', link: '/about' }
    ]
  }

  constructor(private store: Store<State>, private router: Router) {
    this.user = this.store.select(AppFields.App, AppFields.User)
  }

  ngOnInit() {}

  public close(name: string) {
    this.show = false
    this.event.emit({ source: 'full-screen-menu', action: 'close' })
    if (name === 'log-out') {
      this.router.navigate(['/'])
      this.store.dispatch({ type: Types.LogOut })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/com/full-screen-menu/full-screen-menu.com.ts